import { useState } from 'react'
import { GridSortModel } from '@microservices/wiskey-react-table-component'

import { useDeleteStyleSettingMutation } from '@redux/api/styleSetting.api'

export const useHandlers = () => {
  const [currentSort, setCurrentSort] = useState<GridSortModel | undefined>([])
  const [styleSettingsDialogOpen, setStyleSettingsDialogOpen] = useState(false)
  const [editingStyleSettingId, setEditingStyleSettingId] = useState<number | null>(null)

  const [deleteStyleSetting] = useDeleteStyleSettingMutation()

  const handleCreateStyleSetting = () => {
    setEditingStyleSettingId(null)
    setStyleSettingsDialogOpen(true)
  }

  const handleEditStyleSetting = (id: number) => {
    setEditingStyleSettingId(id)
    setStyleSettingsDialogOpen(true)
  }

  const handleDeleteStyleSetting = (id: number) => {
    deleteStyleSetting(id)
  }

  const handleCloseStyleSettingsDialog = () => {
    setStyleSettingsDialogOpen(false)
    setEditingStyleSettingId(null)
  }

  const handleSetSorting = (value: GridSortModel | null) => {
    setCurrentSort(value ? value : [])
  }

  return {
    state: { currentSort, styleSettingsDialogOpen, editingStyleSettingId },
    data: { styleSettingsDialogOpen, editingStyleSettingId },
    handlers: {
      handleCreateStyleSetting,
      handleEditStyleSetting,
      handleDeleteStyleSetting,
      handleCloseStyleSettingsDialog,
      handleSetSorting,
    },
  }
}
